import React, { useEffect } from 'react';
import { Common } from '@thecvlb/design-system';
import classNames from 'classnames';

import { selectUser } from 'store';

import Chat from 'widgets/Chat';

import { useAppSelector, useMessages, useZoomCall } from 'hooks';

const ChatSidebar = () => {
  const { channelDetails, channels, markSeen } = useMessages();
  const { isMinimize, isOpenChat, toggleIsOpenChat } = useZoomCall();
  const { userId } = useAppSelector(selectUser);

  useEffect(() => {
    if (!isOpenChat || !channelDetails) return;
    const channel = channels.find((item) => item.channelId === channelDetails._id);
    if (!channel?.unreadMessageCount) return;
    markSeen({ channelId: channel.channelId, userId });
  }, [isOpenChat, channels, channelDetails, markSeen, userId]);

  return (
    <div
      className={classNames('z-20 h-full overflow-hidden bg-white md:rounded-l-3xl md:shadow', {
        hidden: isMinimize,
        'w-0': !isOpenChat,
        'w-full flex-none max-md:absolute md:w-[500px]': isOpenChat
      })}
    >
      <div className="flex items-center justify-between p-8 max-md:hidden">
        <h2 className="text-xl font-bold">Messages</h2>
        <button onClick={toggleIsOpenChat}>
          <Common.Icon className="text-gray" name="close" />
        </button>
      </div>
      <Chat isZoomCall />
    </div>
  );
};

export default ChatSidebar;
